// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../core/Env.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Translator from "@wino/translator";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as LibphonenumberJs from "libphonenumber-js";
import EnENJson from "../languages/en-EN.json";
import FrFRJson from "../languages/fr-FR.json";

let match = Env.context();

let locale = match === "test" ? "en-EN" : "fr-FR";

let languageEnEN = EnENJson;

let languageFrFR = FrFRJson;

let languages = {
  "en-EN": languageEnEN,
  "fr-FR": languageFrFR
};

function t(str) {
  return Translator.t(str, {
    plural: false,
    languages: languages,
    locale: locale
  });
}

function isPlural(int) {
  return Translator.isPlural(int, {
    locale: locale
  }) === 1;
}

function phoneNumberFormat(string) {
  let phoneNumber = LibphonenumberJs.parsePhoneNumberFromString(string);
  if (!(phoneNumber == null)) {
    return phoneNumber.format("INTERNATIONAL").trim();
  }
  if (string.startsWith("+") !== false) {
    return string;
  }
  let arr = string.replace(/\s/g, "").match(/.{1,2}/g);
  if (!(arr == null) && arr.length !== 0) {
    return Stdlib_Array.filterMap(arr, x => x).join(" ");
  } else {
    return "";
  }
}

function toCurrencySymbol(currency) {
  if (currency === "EUR") {
    return "€";
  } else if (currency === "USD") {
    return "$";
  } else {
    return "¥";
  }
}

function numberFormat(locale, value, numberFormatConstructorOptions) {
  return new (Intl.NumberFormat)(locale, numberFormatConstructorOptions).format(value);
}

function currencyFormat(localeOpt, currency, minimumFractionDigitsOpt, maximumFractionDigitsOpt, value) {
  let locale$1 = localeOpt !== undefined ? localeOpt : locale;
  let minimumFractionDigits = minimumFractionDigitsOpt !== undefined ? minimumFractionDigitsOpt : 2;
  let maximumFractionDigits = maximumFractionDigitsOpt !== undefined ? maximumFractionDigitsOpt : 2;
  return numberFormat(locale$1, value, {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    style: "currency",
    currency: currency
  });
}

function decimalFormat(localeOpt, minimumFractionDigits, maximumFractionDigits, useGrouping, value) {
  let locale$1 = localeOpt !== undefined ? localeOpt : locale;
  return numberFormat(locale$1, value, {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    style: "decimal",
    useGrouping: useGrouping
  });
}

function percentFormat(localeOpt, minimumFractionDigits, maximumFractionDigits, value) {
  let locale$1 = localeOpt !== undefined ? localeOpt : locale;
  return numberFormat(locale$1, value, {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    style: "percent"
  });
}

let narrowNoBreakSpace = String.fromCharCode(8239);

function numberUnitToString(unit) {
  if (unit === "kilogram") {
    return "kg";
  } else if (unit === "liter") {
    return "L";
  } else {
    return "g";
  }
}

function unitFormat(unit, minimumFractionDigits, maximumFractionDigits, value) {
  return decimalFormat(undefined, minimumFractionDigits, maximumFractionDigits, undefined, value) + " " + numberUnitToString(unit);
}

function dateTimeFormat(localeOpt, dateStyle, timeStyle, year, month, day, hour, minute, second, value) {
  let locale$1 = localeOpt !== undefined ? localeOpt : locale;
  let dateTimeFormatOptions = Stdlib_Option.isSome(dateStyle) || Stdlib_Option.isSome(timeStyle) ? ({
      dateStyle: dateStyle,
      timeStyle: timeStyle
    }) : ({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second
    });
  return new (Intl.DateTimeFormat)(locale$1, dateTimeFormatOptions).format(value);
}

let timeZone = new (Intl.DateTimeFormat)(undefined, undefined).resolvedOptions().timeZone;

function listFormat(style, type_, list) {
  return new (Intl.ListFormat)(locale, {
    style: style,
    type: type_
  }).format(list);
}

function template(prim0, prim1, prim2) {
  return Translator.template(prim0, prim1 !== undefined ? Primitive_option.valFromOption(prim1) : undefined);
}

let currencyEur = "EUR";

let currencyUsd = "USD";

let currencyCny = "CNY";

function dateTimeFormatConstructor(prim0, prim1, prim2) {
  return new (Intl.DateTimeFormat)(prim0 !== undefined ? Primitive_option.valFromOption(prim0) : undefined, prim1 !== undefined ? Primitive_option.valFromOption(prim1) : undefined);
}

export {
  locale,
  t,
  isPlural,
  template,
  phoneNumberFormat,
  currencyEur,
  currencyUsd,
  currencyCny,
  toCurrencySymbol,
  currencyFormat,
  decimalFormat,
  percentFormat,
  narrowNoBreakSpace,
  numberUnitToString,
  unitFormat,
  dateTimeFormatConstructor,
  dateTimeFormat,
  timeZone,
  listFormat,
}
/* match Not a pure module */
